import React from 'react'

interface IconProps {
  size?: number
  color?: string
  strokeWidth?: number
  className?: string
}

export const CalendarDaysIcon: React.FC<IconProps> = ({
  size = 24,
  color = 'currentColor',
  strokeWidth = 2,
  className = '',
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {/* Calendar body */}
      <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />

      {/* Calendar header */}
      <path d="M16 2V6" />
      <path d="M8 2V6" />
      <path d="M3 10H21" />

      {/* Calendar days */}
      <path d="M8 14H8.01" />
      <path d="M12 14H12.01" />
      <path d="M16 14H16.01" />
      <path d="M8 18H8.01" />
      <path d="M12 18H12.01" />
      <path d="M16 18H16.01" />
    </svg>
  )
}

export default CalendarDaysIcon
